import { render, staticRenderFns } from "./CountdownBook.vue?vue&type=template&id=f4a246ce&"
import script from "./CountdownBook.vue?vue&type=script&lang=js&"
export * from "./CountdownBook.vue?vue&type=script&lang=js&"
import style0 from "./CountdownBook.vue?vue&type=style&index=0&id=f4a246ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports